<template>
  <section class="print">
    <header>
      <img src="/images/dps.png">
    </header>
    <hr>
    <div class="content p-1">
      <div class="mb-2">
        <div class="button">
          {{ region }}
        </div>
      </div>
      <div
        v-for="(player, index) in players"
        class="p-1"
      >
        <div class="is-flex flex-row align-center">
          <div class="num text-center mr-4">
            {{ player.position }}
          </div>
          <div class="subtitle is-6 mr-4 mb-0">
            <strong class="has-text-info mr-4">
              {{ player.Name }}
            </strong>
            <small>{{ player['AHL Num'] }}</small>
          </div>
          <template v-for="field in array_keys(index)">
            <div v-if="is_allowed_key(field)">
              <small class="mr-4">{{ field }}:</small>
              <small class="has-text-info">{{ player[field] }}</small>
            </div>
          </template>
        </div>
      </div>
    </div>
    <hr>
    <div class="footer">
      <p>
        <strong>Copyright ©2007-{{ currentYear }} AHLPoker.com </strong>All rights reserved.
      </p>
      <p>
        <small><a href="https://www.facebook.com/Zeggle/">Website and Programming created for AHL by Zeggle inc.</a></small>
      </p>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {}
    },
    computed: {
      currentYear () {
        let now = new Date()
        return now.getFullYear()
      },
      region () {
        return this.$route.params.region
      },
      players () {
        return this.$route.params.players
      }
    },
    mounted () {
      window.print()
    },
    methods: {
      is_allowed_key(field) {
        return (
                  field !== 'AHL Num' &&
                  field !== 'Name' &&
                  field !== 'position' &&
                  field !== 'memberphoto' &&
                  field !== 'Handle' &&
                  field !== 'State'
        )
      },
      array_keys(index) {
        return Object.keys(this.$route.params.players[index])
      }
    }
  }
</script>
